import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=e95d7806&scoped=true&"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=e95d7806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95d7806",
  null
  
)

export default component.exports